import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.match.js";
import { getHost, normalize } from './url';
var domains = [/qq\.com$/, /qlogo\.cn$/, /gtimg\.com$/, /gtimg\.cn$/, /qpic\.cn$/, /sinaimg\.cn$/];

function _canSkip(url) {
  var host = getHost(url);
  return domains.filter(function (v) {
    return v.test(host);
  }).length === 0;
}

export function createNormalizer() {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var url = args[0];
    var useRelative = args[1];

    if (!/^(http:|https:|\/\/)/.test(url) && useRelative !== false || _canSkip(url)) {
      return url;
    } // 踩坑：避免离线包场景下，url 使用绝对协议却被转为 file 协议
    // reviewed by: tonicli


    if (!args[2] && !useRelative && !location.protocol.match(/^https?:/)) {
      args[2] = 'https:';
    }

    return normalize.apply(void 0, args);
  };
}
export default {
  createNormalizer: createNormalizer
};